const DEFAULT_FAVOURITE = false;

export default DEFAULT_FAVOURITE;
